import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";

import { useUser, usePopup, useData, useMenu, useLang, useLoading } from "../zustand/store.js";
import { LangText } from "../zustand/dict.js";

import consts from '../libs/consts';
import images from "../libs/images"
import InputFileDrag from '../components/InputFileDrag';
import InputSimple from '../components/InputSimple.js';
import Button from '../components/Button';
import Selector from '../components/Selector';
import RadioImage from "../components/RadioImage";
import Radio from "../components/Radio";
import InputRange from "../components/InputRange";
import InputRangeDual from "../components/InputRangeDual";

import * as APIS from "../utils/service.js";
import Modal from "../components/Modal.js";
import { loadImage } from "../utils/utils.js";
/**
 * 영상 스타일 합성하기
 * @returns 
 */
export default function Menu7() {
    const navigate = useNavigate();
    const location = useLocation();

    const { menu, getMenu } = useMenu();
    const { country, getLang } = useLang();

    const { bears, token, options, isReload, reload, setData, addABear } = useUser();
    const { open, title, popOpen, popClose } = usePopup();
    const { setLoading } = useLoading();

    const [config, setConfig] = useState({});
    const [limitSize, setLimitSize] = useState(10000000000)

    const [video, setVideo] = useState(null);
    const [videoError, setVideoError] = useState(false);
    const [videoInfoError, setvideoInfoError] = useState(false);
    const [mediaInfo, setMediaInfo] = useState(null);

    const [styleType, setStyleStyle] = useState(0);
    const [styleIndex, setStyleIndex] = useState(0);
    const [isStyleUpload, setIsStyleUpload] = useState(false);
    const [styleFile, setStyleFile] = useState(null);

    const [startTime, setStartTime] = useState(0);
    const [endTime, setEndTime] = useState(0);

    const [layout, setLayout] = useState(0);

    const [videoScale, setVideoScale] = useState(0);
    const [styleScale, setStyleScale] = useState(0);
    const [outScale, setOutScale] = useState(0);

    const [share, setShare] = useState(false);

    const [calcPoint, setCalcPoint] = useState(0);

    const [modal, setModal] = useState(consts.defaultModalValue)

    const onMetaData = (metaData) => {
        setVideoError(false)
        setvideoInfoError(false);

        if (metaData) {
            if (metaData?.height > 1080) {
                setVideoError(true)
                setMediaInfo(null)
            } else {
                setVideoError(false);
                let point = getMenu({ idx: 7 })?.point
                let result = metaData.width * metaData.height * metaData.duration / point

                setMediaInfo(metaData);
                setStartTime(0)
                setEndTime(Math.floor(metaData.duration))
            }
        } else {
            console.log("metadata error")
            setVideoError(false);
            setvideoInfoError(true);
            setMediaInfo(null);
            setCalcPoint(0);
            setEndTime(0)
        }
    }

    const defaultSetOption = (configData) => {
        let error = false

        if ("option_selector_video_contents" in configData) {
            setStyleStyle(configData.option_selector_video_contents[0]?.idx)
        } else {
            error = true
        }

        if ("option_selector_layout_video" in configData) {
            setLayout(configData.option_selector_layout_video[0]?.idx)
        } else {
            error = true
        }

        if ("option_slide" in configData) {
            console.log(configData.option_slide)
            setVideoScale(configData.option_slide.video?.default)
            setStyleScale(configData.option_slide.style?.default)
            setOutScale(configData.option_slide.videoMulti?.default)
        } else {
            error = true
        }

        if (error) {
            // setConfigError(error)
        }

        if (location.state?.artData) {
            setLoading(true)
            setTimeout(() => {
                setLoading(false)
                setLoadFunc(location.state?.artData, configData)
            }, 1000)
        }
    }

    const setLoadFunc = async (artData, configData) => {
        console.log("다시만들기")
        console.log("🚀 ~ setLoadPrec ~ artData:", artData)

        if (artData?.contentType) {
            let data = configData?.option_selector_video_contents?.find(v => v.value == artData?.contentType)
            console.log("🚀 ~ setLoadFunc ~ data:", data)
            if (data) {
                setStyleStyle(data.idx);
            }
        }

        if (artData?.videoStyle) {
            let dataIndex = configData?.option_image_style?.findIndex(v => v.value == artData?.videoStyle)
            if (dataIndex >= 0) {
                setStyleIndex(dataIndex)
            }
        } else if (artData?.imageStyleFile) {
            setIsStyleUpload(true);
            let imageData = await loadImage(consts.imgUrl + artData?.imageStyleFile)
            setStyleFile(imageData)
        }

        if (typeof artData?.videoStrength == "number") {
            setVideoScale(artData?.videoStrength)
        }

        if (typeof artData?.styleStrength == "number") {
            setStyleScale(artData?.styleStrength)
        }

        if (artData?.layoutOption) {
            let data = configData?.option_selector_layout_video?.find(v => v.value == artData?.layoutOption)
            if (data) {
                setLayout(data.idx);
            }
        }

        if (artData?.multipleOption) {
            setOutScale(artData?.multipleOption)
        }
    }

    const configDataFunc = () => {
        APIS.post('/config/option').then(({ data }) => {
            setConfig(data);
            defaultSetOption(data)
        }).catch((e) => {
            console.log(e.response);
        });
    }

    /**
     * 비디오 만들기
     * @returns 
     */
    const makeVideoFunc = () => {
        let sendData = {
            video: video,
            videoInfo: mediaInfo,
            startTime: startTime,
            endTime: endTime,
            contentType: styleType,
            videoStyle: "",
            styleStrength: "",
            videoStrength: "",
            layout: layout,
            multi: Number(outScale),
            share: !share
        }

        //비디오 검증
        if (!video) {
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: "error_input_video" })
            })
            return
        }

        if (isStyleUpload) {
            if (!styleFile) {
                setModal({
                    ...modal,
                    open: true,
                    message: getLang({ key: "error_input_style" })
                })
                return;
            }
            sendData.videoStyle = styleFile
        } else {
            sendData.videoStyle = config.option_video_style[styleIndex].idx
        }

        sendData.videoStrength = Number(videoScale)
        sendData.styleStrength = Number(styleScale)

        console.log("🚀 ~ makeVideoFunc ~ sendData:", sendData)

        setLoading(true);
        APIS.post("/aiVideo/merge", sendData).then(({ data }) => {
            if (data) console.log("/aiVideo/merge:", data);
            setLoading(false);
            reload();
            navigate("/myart_history")
        }).catch((result) => {
            setLoading(false);
            let data = result.response.data;
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: data.msgkey })
            })
        })
    }


    useEffect(() => {
        configDataFunc();
        if (getMenu({ idx: 7 })?.limit) {
            setLimitSize(getMenu({ idx: 7 })?.limit * 1000 * 1000 * 1000)
        }
    }, [])

    useEffect(() => {
        if (mediaInfo) {
            let point = getMenu({ idx: 7 })?.point
            let result = mediaInfo.width * mediaInfo.height * (endTime - startTime) / point
            console.log("🚀 ~ useEffect ~ result:", result)
            if (result < 1) {
                result = 1;
            }
            setCalcPoint(Math.floor(result));
        }

    }, [startTime, endTime])

    const modalConfirm = () => {
        if (modal.type === "test") {

        } else {
            modalClose();
        }
    }

    const modalClose = () => {
        setModal(consts.defaultModalValue)
    }

    return (
        <>
            <Modal
                open={modal.open}
                setOpen={(v) => {
                    setModal({ ...modal, open: v })
                }}
                title={modal.title}
                message={modal.message}
                onConfirm={modalConfirm}
                onCancel={modal.isClose ? () => { modalClose(); } : null}
            />

            <div className="content">
                <div className="title_box3">
                    <div className="text_area">
                        <p className="title">
                            <LangText id={getMenu({ idx: 7 }).title_key} />
                        </p>
                        <p className="sub_title">
                            <LangText id={getMenu({ idx: 7 }).info_key} />
                        </p>
                    </div>
                    <div className="thumb">
                        {/* <img src={consts.imgUrl + getMenu({ idx: 7 })?.image?.ko} /> */}
                        <img src={consts.imgUrl + getMenu({ idx: 7 })?.image?.[country]} />
                    </div>
                </div>

                <div className="setting_box">
                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_upload_video" /></p>
                                <p className="body1"><LangText id="info_upload_video" /></p>
                                {videoError && <p className="body1 color-red"><LangText id="error_bigsize_image" /></p>}
                                {videoInfoError && <p className="body1 color-red"><LangText id="err_videoinfo_error" /></p>}
                            </div>
                        </div>

                        <InputFileDrag
                            name="drag-file"
                            valid="video"
                            value={video}
                            limit={limitSize}
                            setValue={setVideo}
                            onMetaData={onMetaData}
                        />
                    </div>

                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_set_video_range" /></p>
                                <p className="body1">
                                    <LangText id="info_set_video_range" />
                                </p>
                            </div>
                        </div>
                        <InputRangeDual
                            startText={moment(startTime * 1000).format("mm:ss")}
                            endText={moment(endTime * 1000).format("mm:ss")}
                            value1={startTime}
                            setValue1={setStartTime}
                            value2={endTime}
                            setValue2={setEndTime}
                            min={0}
                            max={mediaInfo?.duration || 0}
                        />
                    </div>

                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_content_type" /></p>
                            </div>
                        </div>
                        <Radio
                            value={styleType}
                            setValue={setStyleStyle}
                            options={config?.option_selector_video_contents?.map(v => {
                                return { value: v?.idx, label: getLang({ key: v?.title_key }) }
                            })} />
                    </div>

                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_set_image_style" /></p>
                                <p className="body1"><LangText id="info_image_style" /></p>
                            </div>

                            <Button title={isStyleUpload ? getLang({ key: "btn_show_style" }) : getLang({ key: "btn_upload_image_style" })} type={2} onClick={() => {
                                setIsStyleUpload(!isStyleUpload)
                            }} />
                        </div>
                        {!isStyleUpload ? <div className="border_box">
                            <p className="body1"><LangText id="text_style_list" /></p>
                            <RadioImage
                                className="mt-12"
                                options={config?.option_video_style?.map((v) => {
                                    return { title: getLang({ key: v?.title_key }), imgSrc: `${consts.imgUrl}${v?.imgPath}` }
                                })}
                                current={styleIndex}
                                onChange={setStyleIndex}
                            />
                        </div> : <InputFileDrag
                            name="drag-file-style"
                            setValue={setStyleFile}
                        />}
                    </div>

                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_style_ref_set" /></p>
                                <p className="body1">
                                    <LangText id="info_style_ref_set_video" />
                                </p>
                            </div>
                        </div>
                        <InputRange
                            className="mt-24"
                            startText={getLang({ key: "text_str_min" })}
                            endText={getLang({ key: "text_str_max" })}
                            step={config.option_slide?.style?.step}
                            min={config.option_slide?.style?.min || 0}
                            max={config.option_slide?.style?.max || 100}
                            value={styleScale}
                            setValue={setStyleScale}
                            tickerValue={styleScale}
                        />

                    </div>

                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_default_video" /></p>
                                <p className="body1">
                                    <LangText id="info_default_video" />
                                </p>
                            </div>
                        </div>

                        <InputRange
                            className="mt-24"
                            startText={getLang({ key: "text_str_min" })}
                            endText={getLang({ key: "text_str_max" })}
                            step={config.option_slide?.video?.step}
                            min={config.option_slide?.video?.min || 0}
                            max={config.option_slide?.video?.max || 100}
                            value={videoScale}
                            setValue={setVideoScale}
                            tickerValue={videoScale}
                        />
                    </div>

                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_expansion_area" /></p>
                            </div>
                        </div>
                        <Radio
                            value={layout}
                            setValue={setLayout}
                            options={config.option_selector_layout_video?.map((v) => {
                                return { value: v.idx, label: getLang({ key: v?.title_key }) }
                            })} />
                    </div>

                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_expansion_scale" /></p>
                                <p className="body1">
                                    <LangText id="info_expansion_scale" />
                                </p>
                            </div>
                        </div>

                        <InputRange
                            className="mt-24"
                            startText={config.option_slide?.videoMulti?.min}
                            endText={config.option_slide?.videoMulti?.max}
                            step={config.option_slide?.videoMulti?.step}
                            min={config.option_slide?.videoMulti?.min || 0}
                            max={config.option_slide?.videoMulti?.max || 100}
                            value={outScale}
                            setValue={(v) => {
                                console.log(v);
                                setOutScale(v)
                            }}
                            tickerValue={outScale}
                        />
                    </div>
                </div>



                <div className="confirm_box mt-80">
                    <Button
                        type={4}
                        title={getLang({ key: "btn_create_video", replace: { key: "{0}", val: calcPoint } })}
                        round
                        onClick={makeVideoFunc}
                        disable={(video && !videoError && !videoInfoError) ? false : true}
                    />
                    <input
                        type="checkbox"
                        id={"checkShare"}
                        className='checkbox5'
                        checked={share}
                        onChange={(e) => {
                            setShare(e.target.checked)
                        }} />
                    <label className="mt-12" for={'checkShare'}>
                        <LangText id="btn_not_share" />
                    </label>
                </div>
            </div>
        </>
    );
}
